import { ReactNode } from 'react';
import { Box } from '@gemini/core';

const TermsAndConditionsContent = ({ children }: { children: ReactNode }) => {
    return (
        <Box
            as="p"
            typography="typography.body.14.regular"
            marginHorizontal="spacing.16"
            color="color.content.default.default"
            testId="nested-sub-headline"
        >
            {children}
        </Box>
    );
};

export default TermsAndConditionsContent;
